// extracted by css-extract-rspack-plugin
export default {"cls1":"Comments-cls1_dg0","cls2":"Comments-cls2_P5f Comments-cls1_dg0"};